/**
 *
 * Custom BigInt exponentiation function. This is a workaround because  TypeScript tsconfig.json file's
 * target option is set to a version of JavaScript earlier than es2016, which does not support
 * bigint exponentiation (** operator).
 * @param base - The base as a bigint.
 * @param exp - The exponent as a bigint.
 * @returns The result of base ** exp as a bigint.
 */
export const bigintPow = (base: bigint, exp: bigint): bigint => {
    let result = BigInt(1)
    while (exp > 0) {
        if (exp % BigInt(2) === BigInt(1)) {
            result *= base
        }
        base *= base
        exp /= BigInt(2)
    }
    return result
}
